import { AfterViewInit, Component, Input } from '@angular/core';
import { GalleryService } from '../../../../shared/services';

@Component({
  selector: 'app-story-docs',
  templateUrl: './story-docs.component.html',
  styleUrls: ['./story-docs.component.scss']
})
export class StoryDocsComponent implements AfterViewInit {

  @Input() public gallery: any[];
  @Input() public isMobile;
  @Input() public slidesPerView = 6.5;
  breakpoints = {
    600: { perView: 3.5 },
    992: { perView: 6.5, focusAt: 0 }
  };

  constructor(
    private galleryService: GalleryService
  ) { }

  ngAfterViewInit() {
    // this.galleryService.initGallery('lightgalleryStoryDocs');
  }
}
